import React from "react";
import IconButton from "@mui/material/IconButton";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import TextInput from "./TextInput";

export default function CompactNumberInput({
  onChange,
  disabled,
  className = "",
  min,
  max,
  clampToBounds = false,
  ...props
}) {
  const inputRef = React.useRef(null);
  const handleChange = (event) => {
    const input = event.target;
    if (clampToBounds && input.value !== "") {
      const value = Number(input.value);
      if (min !== undefined && value < Number(min)) input.value = String(min);
      if (max !== undefined && value > Number(max)) input.value = String(max);
    }
    onChange(event);
  };
  const step = (direction) => {
    const input = inputRef.current;
    if (direction > 0) input.stepUp();
    else input.stepDown();
    handleChange({ target: input, currentTarget: input });
  };
  return (
    <TextInput
      {...props}
      min={min}
      max={max}
      ref={inputRef}
      type="number"
      disabled={disabled}
      className={`bpm-input ${className}`}
      onChange={handleChange}
      endAdornment={
        <span className="bpm-stepper">
          <IconButton
            aria-label={`Increase ${props["aria-label"] || "BPM"}`}
            disabled={disabled}
            onClick={() => step(1)}
          >
            <ArrowDropUp />
          </IconButton>
          <IconButton
            aria-label={`Decrease ${props["aria-label"] || "BPM"}`}
            disabled={disabled}
            onClick={() => step(-1)}
          >
            <ArrowDropDown />
          </IconButton>
        </span>
      }
    />
  );
}
